import React from 'react';
import { Stack } from '@mui/material';
import FormatUtils from 'js/lib/FormatUtils';
import { Info } from 'new/components/monitor/components/Info';
import { ViewType } from '../../constants/viewTypes';

// Styles
import s from './AccountUsageMetrics.module.scss';

interface AccountUsageMetricsProps {
  metrics: any;
  daysDiff: number;
  viewType: ViewType;
  isLoading?: boolean;
}

export const AccountUsageMetrics = ({
  metrics,
  viewType,
  daysDiff,
  isLoading = false,
}: AccountUsageMetricsProps) => {
  return (
    <div className={s.dataUsageContainer}>
      {/* Data Records */}
      <div className={s.dataUsageItem}>
        <div>
          <Stack width="100%" direction="row" alignItems="baseline" justifyContent="space-between">
            <Info
              label="Total Records"
              value={FormatUtils.formatNamedNumber(metrics?.data?.records)}
              loading={isLoading}
            />
            <span className={s.daysAgo}>
              {daysDiff} days · {viewType}
            </span>
          </Stack>

          <span className={s.totalAcrossSelectedDateRange}>Total across selected date range</span>
        </div>
      </div>

      {/* Data Volume */}
      <div className={s.dataUsageItem}>
        <div>
          <Stack width="100%" direction="row" alignItems="baseline" justifyContent="space-between">
            <Info
              value={FormatUtils.bytesToString(metrics?.data?.size)}
              label="Data Volume"
              loading={isLoading}
            />
            <span className={s.daysAgo}>
              {daysDiff} days · {viewType}
            </span>
          </Stack>

          <span className={s.totalAcrossSelectedDateRange}>Processed this period</span>
        </div>
      </div>
    </div>
  );
};
